import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/dev': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M120.1 208.3C116.2 205.4 112.3 203.9 108.5 203.9H91V308.4H108.5C112.4 308.4 116.3 307 120.1 304.1 124 301.2 126 296.8 126 291V221.3C125.9 215.5 124 211.2 120.1 208.3zM404.1 32H43.9C19.7 32 0.1 51.6 0 75.8V436.2C0.1 460.4 19.7 480 43.9 480H404.1C428.3 480 447.9 460.4 448 436.2V75.8C447.9 51.6 428.3 32 404.1 32zM154.2 291.2C154.2 310 142.6 338.5 105.8 338.4H59.4V173H106.8C142.3 173 154.2 201.4 154.2 220.3L154.2 291.2zM254.9 202.5H201.6V240.9H234.2V270.5H201.6V308.9H254.9V338.5H192.7C181.6 338.8 172.3 330 172 318.8V193.7C171.7 182.5 180.6 173.3 191.7 173H254.9L254.9 202.5zM358.5 317.8C345.3 348.6 321.7 342.4 311.1 317.8L272.6 173H305.1L334.8 286.7 364.4 173H397L358.5 317.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/dev.js
// module id = g+4P
// module chunks = 144